












import { isString } from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AuthErrorAlert extends Vue {
  @Prop() readonly errors!: any;

  get errorsLocal() {
    if (isString(this.errors)) {
      return [[this.errors]];
    }
    return this.errors;
  }
}
